import {
    iconRequest,
    iconClient,
    iconReports,
    iconReportsDefault,
    iconSendMsms,
    iconSearch,
    iconParameters,
    iconParametersGyg,
    iconDocs,
    DocsDesembolsados,
    iconFasecolda,
    iconWarranty,
    iconPolizas,
    iconAseguradoras,
} from '../defaultValues';

const data = {
    role_3ceb9090013b4b1bba84b00f2a05995a: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            to: '/app/radicationWarranty',

        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'gyg',
                    icon: iconParametersGyg,
                    label: 'G&G',
                    to: '/app/gyg/parameterGyg',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/CalculatorParams',
                },
            ],
        },
        {
            id: 'sendSms',
            icon: iconSendMsms,
            label: 'SMS',
            to: '/app/sms/EnvioSms',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/ReportsDisbursement',
                },
                {
                    icon: iconClient,
                    label: 'Terceros',
                    to: '/app/reports/ReportThirds',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Garantías Comunitarias',
                    to: '/app/reports/CommunityGuarantees',
                },
            ],
        },
        {
            id: 'newoptions',
            icon: iconPolizas,
            label: 'Operaciones',
            to: '/app/calculator',
            subs: [
                {
                    id: 'polizas',
                    icon: iconAseguradoras,
                    label: 'Seguros endosados',
                    to: '/app/Polizas',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'documents',
                    icon: DocsDesembolsados,
                    label: 'Desembolsados',
                    to: '/app/credits/DisbursementDocuments',
                },
                {
                    id: 'senFasecolda',
                    icon: iconFasecolda,
                    label: 'Fasecolda',
                    to: '/app/reportFasecolda/Fasecolda',
                },
            ],
        },
    ],
};
export default data;
